import { render, staticRenderFns } from "./form-export-resource.vue?vue&type=template&id=d0a1a55c"
import script from "./form-export-resource.vue?vue&type=script&lang=js"
export * from "./form-export-resource.vue?vue&type=script&lang=js"
import style0 from "./form-export-resource.vue?vue&type=style&index=0&id=d0a1a55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports